// params dateObj - date object , lang - en-US/de-DE 
export function formatDateWithLang(dateObj, lang) {
    return new Intl.DateTimeFormat(lang, {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    }).format(dateObj)
}

// calculate the days difference between two dates from-2/7/2022, to-2/14/2022, MM/DD/YYYY  
export function getDaysDifference(from, to) {
    let date1 = new Date(from);
    let date2 = new Date(to);
    let diffDays = parseInt((date2 - date1) / (1000 * 60 * 60 * 24), 10);
    return diffDays;
}

//Get the Month, Day, Year from dateObj
export function getMonthDayYear(dateObj) {
    let month = String(dateObj.getMonth() + 1).padStart(2, '0');
    let day = String(dateObj.getDate()).padStart(2, '0');
    let year = dateObj.getFullYear();
    return {
        month: month,
        day: day,
        year: year
    }
}

//Check valid date string or not
export function isDateValid(dateStr) {
    const d = new Date(dateStr);
    // If the date object is invalid it will return 'NaN' on getTime() and NaN is never equal to itself.
    if (d.getTime() === d.getTime()) {
        return true;
    }
    return false;
}

// create date using seperator and date parts
export function parseDate(str, lang){
    const datePatternInfo = buildDatePatternInfo(lang);
    if (!str) {
        return null
    }
    let format = parseFormat(datePatternInfo.formatPattern);
    const parts = str.split(format.separator);
    const dateParts = createDate(parts, format);
    return new Date(dateParts.year, dateParts.month, dateParts.day);
}

// to parse the date format which will return the seperator and parts
export function parseFormat(format){
    var separator = format.match(/[.\/\-\s].*?/),
        parts = format.split(/\W+/);
    if (!separator || !parts || parts.length === 0) {
        throw new Error("Invalid date format.");
    }
    return { separator: separator, parts: parts };
}

export function createDate(parts, format){
    var val;
    let dateParts = {};
    if (parts.length === format.parts.length) {
        for (let i = 0, cnt = format.parts.length; i < cnt; i++) {
            val = parseInt(parts[i], 10) || 1;
            switch (format.parts[i]) {
                case 'DD':
                case 'D':
                case 'dd':
                case 'd':
                    dateParts['day'] = val;
                    break;
                case 'MM':
                case 'M':
                case 'mm':
                case 'm':
                    dateParts['month'] = (val - 1);
                    break;
                case 'YY':
                case 'yy':
                    dateParts['year'] = (2000 + val);
                    break;
                case 'YYYY':
                case 'yyyy':
                    dateParts['year'] = val;
                    break;
            }
        }
    }
    return dateParts;
}

// date pattern based on 'lang' attribute (en-US, de-DE) to be passed in maskOptions 
export function buildDatePatternInfo (lang){
    const parts = new Intl.DateTimeFormat(lang, {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    }).formatToParts(new Date());

    return parts.reduce((acc, {
        type, value
    }) => {
        switch (type) {
            case 'month':
                acc.maskOptions.mask += 'm';
                acc.formatPattern += 'MM';
                break;
            case 'day':
                acc.maskOptions.mask += 'd';
                acc.formatPattern += 'DD';
                break;
            case 'year':
                acc.maskOptions.mask += 'y';
                acc.formatPattern += 'YYYY';
                break;
            default:
                acc.maskOptions.mask += `\`${value}`;
                acc.formatPattern += `${value}`;
        }

        return acc;
    }, {
        maskOptions: {
            mask: ''
        },
        formatPattern: ''
    });
};

export function formatToParts(date, lang){
    const parts = new Intl.DateTimeFormat(lang, {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    }).formatToParts(date)

    return parts.reduce((acc, { type, value }) => {
        if (type === 'month' || type === 'day' || type === 'year') {
            acc[type] = value
        }
        return acc
    }, {})
}

export function getLocalTimeZone(date) {
    return new Date(date.getTime() + (date.getTimezoneOffset() * 60 * 1000));
}

export function langSpecificTimeZone(date, lang, displayFormat) {
    return new Intl.DateTimeFormat(lang, displayFormat).format(getLocalTimeZone(new Date(date)));
}